import { useEffect, useState } from "react";
import { TrendingUp, Eye, Sparkles, Loader2 } from "lucide-react";
import { getTopPerformers, mediaUrl } from "../lib/api";

export default function TopPerformers() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getTopPerformers().then(setData).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="flex justify-center py-6"><Loader2 className="h-5 w-5 animate-spin text-muted-foreground" /></div>;
  }
  if (!data || data.totals.clips_shared === 0) {
    return (
      <div className="border border-dashed border-border p-6 text-center" data-testid="top-performers-empty">
        <TrendingUp className="mx-auto mb-2 h-5 w-5 text-muted-foreground" />
        <p className="font-mono text-xs text-muted-foreground">
          Share a clip's link and its views + signups will rank here — your growth dashboard.
        </p>
      </div>
    );
  }

  return (
    <div className="border border-accent/30 bg-accent/[0.04] p-5" data-testid="top-performers">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-accent">
          <TrendingUp className="h-4 w-4" />
          <span className="font-mono text-[11px] uppercase tracking-[0.25em]">Top performing shares</span>
        </div>
        <div className="flex gap-5 font-mono text-[11px] text-muted-foreground">
          <span className="flex items-center gap-1.5"><Eye className="h-3.5 w-3.5" /> {data.totals.views} views</span>
          <span className="flex items-center gap-1.5 text-accent"><Sparkles className="h-3.5 w-3.5" /> {data.totals.signups} signups</span>
        </div>
      </div>
      <div className="mt-4 space-y-2">
        {data.clips.slice(0, 6).map((c, i) => (
          <div key={c.id} data-testid={`top-performer-${i}`} className="flex items-center gap-3 border border-border bg-card p-2.5">
            <span className="w-5 text-center font-display text-sm text-muted-foreground">{i + 1}</span>
            {c.poster ? (
              <img src={mediaUrl(c.poster)} alt={c.title} className="h-11 w-8 shrink-0 rounded object-cover" />
            ) : (
              <div className="h-11 w-8 shrink-0 rounded bg-secondary" />
            )}
            <div className="min-w-0 flex-1">
              <p className="truncate font-body text-sm text-white">{c.title}</p>
              <p className="truncate font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{c.show_title}</p>
            </div>
            <div className="flex shrink-0 gap-4 font-mono text-[11px]">
              <span className="flex items-center gap-1 text-muted-foreground"><Eye className="h-3 w-3" /> {c.share_views}</span>
              <span className="flex items-center gap-1 text-accent"><Sparkles className="h-3 w-3" /> {c.share_signups}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
